module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/icons-extension-249ccd20ca6174097ff77bd4fcab4a4f.svg";